var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',{attrs:{"multiple":"","row":""}},_vm._l((_vm.item.suites),function(suite,suiteId){return _c('v-chip',{key:suiteId,attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.suitesConfig.getSuiteLabel(suiteId))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }